import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { InsertSupportBody, SearchSupportsResponse, UpdateSupportBody } from "./types/supports";

export const useDeckSupportsApi = () => {
  const crud = createAdminCrudApi<SearchSupportsResponse, InsertSupportBody, UpdateSupportBody>(
    useApi(),
    DECK_ADMIN_URL,
    "supports",
  );

  return {
    useDeckSupports: crud.useSearch,
    insertDeckSupport: crud.insert,
    updateDeckSupport: crud.update,
    deleteDeckSupport: crud.remove,
    updateDeckSupportVisibility: crud.updateVisibility,
    updateDeckSupportOrder: crud.updateOrder,
  };
};

export default useDeckSupportsApi;
